module.exports = __webpack_public_path__ + "media/kk.3ef6e1dc.mp4";